<script setup lang="ts">
/********************
 * PROPS & EMITS     *
 ********************/
export interface InputCheckboxProps {
  allowHtml?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  id: string;
  isInline?: boolean;
  label: string;
  required?: boolean;
  value?: boolean;
}
const props = withDefaults(defineProps<InputCheckboxProps>(), {
  allowHtml: false,
  disabled: false,
  hasError: false,
  isInline: false,
  required: false,
  value: false,
});

const emit = defineEmits<{
  input: [value: boolean];
}>();
</script>

<template>
  <div
    class="mb-6"
    :class="{ 'has-error': props.hasError }"
  >
    <input
      :id="props.id"
      :name="props.id"
      class="input-field--checkbox absolute opacity-0"
      type="checkbox"
      :disabled="props.disabled"
      :checked="props.value"
      @click="emit('input', !props.value)"
    />
    <label
      :for="props.id"
      :class="{ inline: props.isInline }"
      class="input-label input-label--inline input-label--for-checkbox relative cursor-pointer p-0 pl-[35px] !font-normal"
    >
      <span
        v-if="props.allowHtml"
        v-html="props.label"
      />
      <span v-else>{{ props.label }}</span>
    </label>
  </div>
</template>

<style lang="postcss" scoped>
.input-field--checkbox {
  &:checked + .input-label--for-checkbox:after {
    @apply block;
  }
}

.input-label--for-checkbox {
  &:before {
    @apply size-[25px] left-0 inline-block absolute align-text-top content-[''] mr-[10px] bg-gray-10 top-1/2 -translate-y-1/2;
    border-radius: 4px;
  }

  &:after {
    @apply bg-transparent hidden h-[15px] w-[8px] absolute content-[''] top-1/2  -translate-y-1/2 left-[9px] border-dark-green border-2 border-solid border-l-0 border-t-0;
    transform: translateY(-9px) rotate(45deg);
  }
}

.has-error {
  .input-label--for-checkbox::before {
    @apply border border-danger;
  }
}
</style>
